export default __webpack_public_path__ + "static/media/certificate_second.78e9b8b3.jpg";